<!--Copy right - © 2024 tecera gmbh-->
<script>
    import {
        is_authenticated,
        check_if_authenticated,
        user_permissions,
        rerout_user,
    } from "../scripts/auth.js";
    import {fetchVehicles,get_alarms_current_vehicles,
        get_alarms_old_vehicles,} from "../scripts/vehicles.js";
    import { onDestroy, onMount } from "svelte";
    import {
        all_hymos,
        selected_device,
        map_center,
        hymo_alarms_triggered_new,
        hymo_alarms_triggered_old,
        modal_mode,
        is_modal_open,
        free_hymos,
        current_device_data,
        last_meta_data,
        hymo_data_end_date,
        all_devices,
    } from "../stores.js";
    import {
        ALARM_REFRESH_INTERVALL_IN_SECONDS,
        DATA_REFRESH_INTERVALL_IN_SECONDS,
        ENABLE_LIVE_RELOADING,
    } from "../config.js";
    import NavBar from "../components/NavBar.svelte";
    import Footer from "../components/Footer.svelte";
    import SignalDisplay from "../components/SignalDisplay.svelte";
    import VehicleMap from "../components/VehicleMap.svelte";
    import NeuesGeraetButton from "../components/buttons/NeuesGeraetButton.svelte";
    import VehicleModal from "../components/modals/VehicleModal.svelte";
    import VehicleButton from "../components/buttons/VehicleButton.svelte";
    import Meldungen from "../components/Meldungen.svelte";
    import VehicleMeldungEntry from "../components/VehicleMeldungEntry.svelte";
    import DeviceSearchField from "../components/DeviceSearchField.svelte";
    import GrenzwerteVehicleButton from "../components/buttons/GrenzwerteVehicleButton.svelte";
    import VehicleAlarmAuswahl from "../components/VehicleAlarmAuswahl.svelte";
    import VehicleAlarmKreisModal from "../components/modals/VehicleAlarmKreisModal.svelte";
    import SegmentControl2 from "../components/SegmentControl2.svelte";

    let show_loaders = false;
    let show_old_alarms = false;
    let device_search_input = "";
    let init_alarm_fetch = true;
    let alarm_fetch_interval, data_fetch_interval;
    let is_alarmierungskreis_modal_open = false;
    var end_date = moment(); // Now
    var start_date = moment().subtract(5, "days"); // 5 days ago
    let chosen_segment = "Fahrzeuge";
    let is_mounted = false;
    let data_promise;
    let all_vehicles = [];

    //config?

    onMount(async () => {
        is_mounted = true;
        $selected_device = null; // need to set this to null incase user comes from different tab
        await check_if_authenticated(); // waiting for auth before proceeding
        data_promise = new Promise((resolve) => { // int loader
            setTimeout(() => {
                resolve("Fake data for loader");
            }, 500);
        });
        // check for user permissions
        if (
            !$user_permissions["access_vehicles"] ||
            $user_permissions["access_vehicles"] != 1
        ) {
            rerout_user();
            return;
        }
        // iniitialize devices
        fetch_vehicles(true);
        get_alarms();


        if (ENABLE_LIVE_RELOADING) {
            alarm_fetch_interval = setInterval(
                get_alarms,
                ALARM_REFRESH_INTERVALL_IN_SECONDS * 1000,
            );
            data_fetch_interval = setInterval(
                () => fetch_vehicles(false,true),
                1000 * 10,
            );
        }
    });


    $: {
        $hymo_data_end_date = end_date;
    }

    async function fetch_vehicles(reset_map = false,smooth_reload = false) {
        let selected_id = $selected_device ? $selected_device.device.id : null;
        if (!smooth_reload){
            show_loaders = true;
        }
        const fetch_result = await fetchVehicles();
        all_vehicles = fetch_result.results;
        if (reset_map) {
            map_center.set([52.022146, 10.566208]);
        } else {
            //TODO FIX
            // $selected_device = all_vehicles[0];
        }
            if (!smooth_reload){
            show_loaders = false;
        } else {
            $selected_device = all_vehicles.find(
                (device) => device.device.id === selected_id,
            );
        }
    }

    async function get_alarms() {
        await get_alarms_current_vehicles();
        init_alarm_fetch = false;
        await get_alarms_old_vehicles();

    }

    onDestroy(() => {
        clearInterval(alarm_fetch_interval);
        clearInterval(data_fetch_interval);
        $all_hymos = [];
        $hymo_alarms_triggered_new = [];
        $hymo_alarms_triggered_old = [];
        $free_hymos = [];
        $selected_device = null;
        $current_device_data = [];
        $last_meta_data = null;
    });

    // reactive centering of the map on the selected device
    $: {
        if (
            $selected_device
        ) {
            select_device();
        }
    }

    function select_device() {
        map_center.set([$selected_device?.last_data?.latitude, $selected_device?.last_data?.longitude]);
        $last_meta_data = $selected_device?.last_data;
        $last_meta_data["rssi"] = 0;
    }
    
</script>

<svelte:head>
    <title>Mapview - Fahrzeugüberwachung</title>
</svelte:head>

{#if $is_authenticated && $user_permissions["access_vehicles"] == 1}
    <div class="container-fluid">
        <div class="row">
            <!-- Main Content -->
            <main class="col-12 ml-sm-auto px-md-4">
                <NavBar headline="Fahrzeugüberwachung" />
                <div class="row">
                    <!-- Linke Seite -->
                    <div
                        class="col-12 col-xl-9 col-lg-8 col-md-7 content_main"
                        style="display:flex;flex-direction:column;justify-content:flex-start;"
                    >
                        <div class="row" style="flex: 0 1 5%;">
                            <!-- Buttons -->
                            <div
                                class="col-9 col-lg-9 col-md-8 pl-3 pt-3 pr-0"
                                style="align-items: flex-start;justify-content: flex-start;display:flex;flex: 1 1 60%;"
                            >
                                <div
                                    class="d-md-flex d-inline justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2"
                                >
                                    <div class="btn-toolbar pb-1">
                                        <NeuesGeraetButton
                                            label={"Neues Fahrzeug"}
                                            func={() => {
                                                $modal_mode = "create";
                                                $is_modal_open = true;
                                            }}
                                            id="hymo_new_device_button"
                                        />
                                    </div>
                                </div>
                            </div>

                            <!-- Letzter Sendezeitraum und Signalstaerke -->
                            <div
                                class="col-3 col-lg-3 col-md-4 p-0 ml-0 pr-2 pt-3"
                                style="align-items: flex-end;justify-content: flex-end;display:flex;flex: 1 0 150px;min-width:fit-content;"
                            >
                                <SignalDisplay />
                            </div>
                        </div>

                        <!-- Map -->
                        <div class="row" style="flex: 5 5 30%;">
                            <div class="col-12 full">
                                <VehicleMap
                                    vehicles={all_vehicles}
                                    alarms_triggered={hymo_alarms_triggered_new}
                                />
                            </div>
                        </div>
                    </div>

                    <!-- Rechte Seite -->
                    {#if chosen_segment === "Fahrzeuge"}
                        <div
                            class="col-12 col-xl-3 col-lg-4 col-md-5 content_main content_main_side"
                            style="display:flex;flex-direction:column;justify-content:flex-start;"
                        >
                            <!-- HyMo Menü -->
                            <div
                                class="row pt-4"
                                style="flex: 1 1 50%;overflow:hidden;"
                            >
                                <div class="col-12 full">
                                    <div class="display_box side-menu">
                                        <SegmentControl2
                                            bind:chosen_segment
                                            segments={[
                                                "Fahrzeuge",
                                                "Grenzwerte",
                                            ]}
                                        />
                                        <p class="p-kachel">Fahrzeuge</p>

                                        <!-- Suchfeld -->
                                        <DeviceSearchField
                                            bind:device_search_input
                                        />

                                        <div class="scroll_window">
                                            <!-- Darstellungsraum der HyMos -->
                                            {#if show_loaders}
                                                <div
                                                    id="loader_devices"
                                                    class="loader"
                                                />
                                            {:else}
                                                {#each all_vehicles as vehicle (vehicle.device.id)}
                                                    {#if vehicle.vehicle_config.length > 0  && (!vehicle.vehicle_config[0].name || vehicle.vehicle_config[0].name
                                                            .toLowerCase()
                                                            .includes(device_search_input.toLowerCase()) || vehicle.device.dev_eui
                                                            .toLowerCase()
                                                            .includes(device_search_input.toLowerCase()))}
                                                        <!-- {#if i === paginated_vehicles.length - 1}
                                                            <div
                                                                use:observe
                                                            >
                                                                <VehicleButton
                                                                    {device_config}
                                                                />
                                                            </div>
                                                        {:else}
                                                            <div
                                                            >
                                                                <VehicleButton
                                                                    {device_config}
                                                                />
                                                            </div>
                                                        {/if} -->
                                                           <VehicleButton
                                                                    vehicle={vehicle}
                                                                />
                                                    {/if}
                                                {/each}
                                            {/if}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Meldungen -->
                            <div
                                class="row pt-4"
                                style="flex: 1 1 50%;overflow:hidden;"
                            >
                                <div class="col-12 full">
                                    <Meldungen bind:show_old_alarms>
                                        {#if init_alarm_fetch}
                                            <div
                                                id="loader_devices"
                                                class="loader"
                                            />
                                        {:else if show_old_alarms}
                                            {#each $hymo_alarms_triggered_old as alarm_triggered (alarm_triggered.id)}
                                                <VehicleMeldungEntry
                                                    {alarm_triggered}
                                                    {show_old_alarms}
                                                    alarm_list={hymo_alarms_triggered_old}
                                                    vehicles={all_vehicles}
                                                />
                                            {/each}
                                        {:else}
                                            {#each $hymo_alarms_triggered_new as alarm_triggered (alarm_triggered.id)}
                                                <VehicleMeldungEntry
                                                    {alarm_triggered}
                                                    {show_old_alarms}
                                                    alarm_list={hymo_alarms_triggered_new}
                                                    vehicles={all_vehicles}
                                                />
                                            {/each}
                                        {/if}
                                    </Meldungen>
                                </div>
                            </div>
                        </div>
                    {:else}
                        <!-- Grenzwerte Menu -->
                        <div
                            class="col-12 col-xl-3 col-lg-4 col-md-5 content_main content_main_side"
                            style="display:flex;flex-direction:column;justify-content:flex-start;flex: 2 2 325px;"
                        >
                            <div
                                class="row pt-4"
                                style="flex: 1 1 50%;overflow:hidden;"
                            >
                                <div class="col-12 full">
                                    <div
                                        class="display_box side-menu side-menu-scroll"
                                    >
                                        <SegmentControl2
                                            bind:chosen_segment
                                            segments={[
                                                "Fahrzeuge",
                                                "Grenzwerte",
                                            ]}
                                        />
                                        <p class="p-kachel">Grenzwerte</p>

                                        <GrenzwerteVehicleButton
                                            all_vehicles={all_vehicles}
                                        />

                                        <div class="input-group mb-2 mt-4">
                                            <button
                                                id="show_alarmierungskreis"
                                                class="btn btn-primary btn-block"
                                                on:click={() => {
                                                    is_alarmierungskreis_modal_open = true;
                                                }}
                                                disabled={$selected_device ? false : true}
                                            >
                                                Alarmierungskreis
                                            </button>
                                        </div>
                                        <VehicleAlarmAuswahl 
                                            all_vehicles={all_vehicles}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/if}
                </div>
            </main>
        </div>
    </div>

    <VehicleModal
        bind:is_open={$is_modal_open}
        bind:all_vehicles={all_vehicles}
    />
    <VehicleAlarmKreisModal bind:is_open={is_alarmierungskreis_modal_open} />
    <Footer />
{/if}
